import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { AutocompleteSearch } from './AutocompleteSearch';
export default function LoadAutocompleteSearch(element) {
    const root = createRoot(element);
    root.render(_jsx(AutocompleteSearch, { maxResults: 8 }));
}
export { AutocompleteSearch };
